import ABSUtils from '@abs/utils';
import ABSLoading from '@abs/core/ABSLoading';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectUser } from 'app/store/userSlice';
import settingsConfig from 'app/configs/settingsConfig';
import "@abs/core/coreConfigs";
import DraftInvoiceConfig from 'app/main/drafts/invoice/InvoiceViewerConfig';
import TimeLiteConfigs from 'app/main/timelite/timeliteConfigs';
import ExkursioConfigs from 'app/main/exkursio/exkursioConfigs';
import BillbuddyConfigs from 'app/main/billbuddy/billbuddyConfigs';
import InventuriusConfigs from 'app/main/inventurius/inventuriusConfigs';
import PersomatConfigs from 'app/main/persomat/persomatConfigs';
import ABSAdministrationConfig from 'app/main/administration/ABSAdministrationConfig';
import UserSettingsConfig from 'app/main/usersettings/UserSettingsConfig';
import errorConfigs from 'app/main/errors/errorConfigs';
import LoginConfig from 'app/main/login/LoginConfig';
import LogoutConfig from 'app/main/logout/LogoutConfig';
import ResetPasswordConfig from 'app/main/password/reset/ResetPasswordConfig';
import ForgotPasswordConfig from 'app/main/password/forgot/ForgotPasswordConfig';
import ChangePasswordConfig from 'app/main/password/change/ChangePasswordConfig';
import ChipInfoConfig from 'app/main/password/chipinfo/ChipInfoConfig';
import ChangelogConfig from 'app/main/changelog/ChangelogConfig';

const routeConfigs = [
  ...TimeLiteConfigs,
  ABSAdministrationConfig,
  UserSettingsConfig,
  ...errorConfigs,
  LogoutConfig,
  LoginConfig,
  ResetPasswordConfig,
  ForgotPasswordConfig,
  ChangePasswordConfig,
  ChipInfoConfig,
  DraftInvoiceConfig,
  ChangelogConfig,
  ...ExkursioConfigs,
  ...BillbuddyConfigs,
  ...InventuriusConfigs,
  ...PersomatConfigs,
];

// Redirects to login when logged out, otherwise to the first available licence in priority order (tl, eo, pm, bb, iv) or usersettings
const HomeRedirect = () => {
  const user = useSelector(selectUser);
  const modules = (user && user.modules) || [];
  if (modules.length === 0) return <Navigate to="/login" />;
  if (modules.includes('tl_default')) return <Navigate to="/tl" />;
  if (modules.includes('eo_default')) return <Navigate to="/eo" />;
  if (modules.includes('pm_default')) return <Navigate to="/pm" />;
  if (modules.includes('bb_default')) return <Navigate to="/bb" />;
  if (modules.includes('iv_default')) return <Navigate to="/iv" />;
  return <Navigate to="/usersettings" />;
};

const routes = [
  ...ABSUtils.generateRoutesFromConfigs(routeConfigs, settingsConfig.defaultAuth),
  {
    path: '/',
    element: <HomeRedirect />,
  },
  {
    path: 'loading',
    element: <ABSLoading />,
  },
  {
    path: '*',
    element: <Navigate to="/error404" />,
  },
];

export default routes;
